import axiosInstance from '../../../helpers/backend_helper';

const deleteContactById = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/v1/contacts/deleteContact/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting contact with ID ${id}:`, error);
    throw error;
  }
};

export default deleteContactById;
